(() => {
  if (window.__gutsuppCartUpgradeBound) return;
  window.__gutsuppCartUpgradeBound = true;
  let busy = false;
  const root = (window.Shopify && window.Shopify.routes.root) || '/';

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-upgrade]');
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const cart = button.closest('form');
    const status = cart && cart.querySelector('.cro-cart-status');
    const controls = cart ? [...cart.querySelectorAll('button, select, input, a[name="checkout"]')] : [button];
    const states = controls.map(el => ({el, disabled:el.disabled, tab:el.getAttribute('tabindex')}));
    controls.forEach(el => {el.disabled = true; el.setAttribute('tabindex', '-1');});
    const stopCheckout = e => {if (e.target.closest('a[name="checkout"]')) e.preventDefault();};
    if (cart) {cart.setAttribute('aria-busy','true');cart.addEventListener('click',stopCheckout,true);}
    button.setAttribute('aria-busy','true');
    if (status) status.textContent = '';
    let changed = false;
    try {
      const currentResponse = await fetch(root+'cart.js', {headers:{Accept:'application/json'}});
      if (!currentResponse.ok) throw new Error('Could not read your cart. Please try again.');
      const current = await currentResponse.json();
      const index = current.items.findIndex(item => item.key === button.dataset.lineKey);
      if (index < 0) throw new Error('Your cart has changed. Refresh the page and try again.');
      const response = await fetch(root+'cart/change.js', {
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({line:index+1,quantity:current.items[index].quantity,selling_plan:Number(button.dataset.sellingPlan),sections:['cart-aside'],sections_url:location.pathname})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Could not update your subscription. Please try again.');
      changed = true;
      if (!data.sections || !data.sections['cart-aside']) {
        const section = await fetch(root+'?section_id=cart-aside');
        if (!section.ok) throw new Error('Your subscription was updated. Refresh to see your cart.');
        data.sections = {'cart-aside':await section.text()};
      }
      const detail = {response:data,handled:false};
      document.dispatchEvent(new CustomEvent('gutsupp:open-cart',{detail}));
      if (!detail.handled) throw new Error('Your subscription was updated. Refresh to see your cart.');
      if (status) status.textContent = 'Subscription added. Your cart total has been updated.';
    } catch (error) {
      if (status) status.textContent = changed ? 'Your subscription was updated. Refresh to see your cart.' : error.message;
    } finally {
      states.forEach(({el,disabled,tab}) => {if(el.isConnected){el.disabled=disabled;if(tab===null)el.removeAttribute('tabindex');else el.setAttribute('tabindex',tab);}});
      button.removeAttribute('aria-busy');
      if (cart) {cart.removeAttribute('aria-busy');cart.removeEventListener('click',stopCheckout,true);}
      busy = false;
    }
  });
})();
